<script lang="ts">
  import IconCircleCheck from '$lib/icons/IconCircleCheck.svelte';
  import IconCircleWarning from '$lib/icons/IconCircleWarning.svelte';
  import IconXmark from '$lib/icons/IconXmark.svelte';
  import { dismissToast } from '$components/toast-manager';
  import { onDestroy, onMount } from 'svelte';
  import Timer from '$components/timer/Timer.svelte';

  type Variant = 'default' | 'positive' | 'negative' | 'attention';

  interface Props {
    variant?: Variant;
    message: string;
    dismissible?: boolean;
  }

  let { variant = 'default', message, dismissible = false }: Props = $props();

  const DURATION = 3000;

  let timeout: never;

  const dismiss = (): void => {
    dismissToast();
  };

  onMount(() => {
    if (!dismissible) {
      timeout = setTimeout(() => dismissToast(), DURATION) as never;
    }
  });

  onDestroy(() => {
    clearTimeout(timeout);
  });
</script>

<div
  data-variant={variant}
  class="
    pointer-events-auto
    relative
    flex
    w-min
    shrink-0
    select-none
    flex-nowrap
    items-center
    justify-center
    overflow-hidden
    whitespace-nowrap
    rounded-2xl
    bg-black
    dark:bg-background-subtle
    bg-opacity-90
    p-4
    typography-body-m-medium
    text-white
    backdrop-blur-sm
    duration-75
  ">
  <span class="flex items-center justify-center gap-4">
    {#if variant === 'default'}
      <span>
        <IconCircleCheck size="sm" />
      </span>
    {/if}
    {#if variant === 'positive'}
      <span class="text-foreground-success-muted">
        <IconCircleCheck size="sm" />
      </span>
    {/if}
    {#if variant === 'negative'}
      <span class="text-foreground-danger-muted">
        <IconCircleWarning size="sm" />
      </span>
    {/if}
    {#if variant === 'attention'}
      <span class="text-foreground-attention-muted">
        <IconCircleWarning size="sm" />
      </span>
    {/if}
    <span>
      {message}
    </span>
    {#if dismissible}
      <button aria-label="Close" type="button" onclick={dismiss}>
        <IconXmark size="sm" />
      </button>
    {:else}
      <Timer duration={DURATION} onclick={dismissToast} />
    {/if}
  </span>
</div>
